// src/hooks/useUpdateTicketStatus.ts
import { useMutation } from "@tanstack/react-query";
import api from "../api"; // your axios instance

export interface UpdateTicketStatusPayload {
  action: "fs-pkp-case-update";
  service_ticket_no: string;
  service_request_status_code: number;
  service_request_remarks?: string;
}

export interface UpdateTicketStatusResponse {
  statusCode: number;
  message: string;
  data?: Record<string, any>;
}

export const useUpdateTicketStatus = () =>
  useMutation<UpdateTicketStatusResponse, Error, UpdateTicketStatusPayload>({
    mutationFn: async (payload) => {
      const { data } = await api.post<UpdateTicketStatusResponse>(
        "/tickets/status/v1",
        payload
      );
      return data;
    },
  });
